import React from 'react';
import './ValidationModal.css'; // Reutilizando os estilos do ValidationModal

const PendenciesModal = ({ pendencies, nodeName, onClose }) => {
  if (!pendencies || pendencies.length === 0) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="validation-modal-backdrop" onClick={handleBackdropClick}>
      <div className="validation-modal">
        <div className="validation-modal-header">
          <h3>⚠️ Avisos encontrados</h3>
          <button className="validation-modal-close" onClick={onClose}>×</button>
        </div>
        
        <div className="validation-modal-content">
          <p className="validation-modal-description">
            {pendencies.length === 1 
              ? 'Foi encontrado um aviso que precisa ser corrigido:' 
              : `Foram encontrados ${pendencies.length} avisos que precisam ser corrigidos:`
            }
          </p>
          
          <div className="validation-modal-list">
            <div className="validation-item">
              <div className="validation-item-header">
                <span className="validation-item-number">1</span>
                <span className="validation-item-title">Nó &ldquo;{nodeName}&rdquo;</span>
              </div>
              <ul className="validation-item-pendencies">
                {pendencies.map((pendency, index) => (
                  <li key={index}>{pendency}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        
        <div className="validation-modal-footer">
          <button className="validation-modal-button primary" onClick={onClose}>
            Corrigir avisos
          </button>
        </div>
      </div>
    </div>
  );
};

export default PendenciesModal;